const { useModuleContext } = require("../context/ModuleContext");

const emptyLifeCycleEventHooks = {
  onReady: () => {},
  onError: () => {},
  onCriticalFailure: () => {},
};

const useModuleLifeCycleEvent = () => {
  const values = useModuleContext();
  const { lifeCycleEvents, name = '', host = '' } = values || {};

  if (!lifeCycleEvents) {
    console.error(`No lifeCycleEvents found in context for host: ${host} & module: ${name}`);
    return emptyLifeCycleEventHooks;
  }

  return lifeCycleEvents;
};

module.exports = useModuleLifeCycleEvent;
module.exports.emptyLifeCycleEventHooks = emptyLifeCycleEventHooks;
